import http from './httpServ'
// import md5 from 'blueimp-md5'
import cache from './cacheServ'
class Cabinet {
    /**
     * 查询设备状态
     * @param id
     * @returns {any|Promise<U>|*}
     */
    getCabinetStatus (qrCode) {
        return http.post(
            `lease/queryCabinetInfoByQrCode?qrCode=${qrCode}`
        )
    }
    // 查询设备是否在时间段内
    getOrderTimeList (qrCode) {
        return http.post(
            `lease/queryOrderTimerList?qrCode=${qrCode}`
        )
    }

    /**(微信)
     * 归还(微信)
     * @returns {any|Promise<U>|*}
     */
    getRepayBed (customerOpenId, orderNo) {
        return http.post(
            `lease/repayBed`,{},
            {
                data: {
                    customerOpenId,
                    orderNo
                }
            }
        )
    }

    /**
     * 查询是租借还是归还(微信)
     * @param id
     * @returns {any|Promise<U>|*}
     */
    getCabinetIsZorF (customerOpenId) {
        return http.post(
            `lease/queryCabinetInfoByOpenId?customerOpenId=${customerOpenId}`
        )
    }
    /**
     * 租借开柜门(微信)
     *
     * @param id
     * @returns {any|Promise<U>|*}
     */
    getOpenByOrder (cabinetNo, customerOpenId, orderNo, qrCode, wxOrderNo) {
        return http.post(
            `lease/cabinetOpenByOrder`,{},{
                data:{
                    cabinetNo,
                    customerOpenId,
                    orderNo,
                    qrCode,
                    wxOrderNo
                }
            }
        )
    }

    /**
     * 查询是否开门成功(微信)
     * @param orderNo
     * @param customerWxId
     * @returns {any|Promise<U>|*}
     */
    getIsOpenDoor (cabinetNo,orderNo,customerOpenId) {
        return http.post(
            `lease/queryCabinetOrderStatus`,{},{
                data:{
                    cabinetNo,
                    orderNo,
                    customerOpenId
                }
            }
        )
    }
        /**
     * 历史订单是否归还,判断设备是否在线,判断设备订单是否已支付,但设备未推出感应区
     */
        queryCabinetOrderInfo (customerOpenId,qrCode,bedNo) {
            return http.post(
                `lease/queryCabinetOrderInfo?qrCode=${qrCode}&customerOpenId=${customerOpenId}&bedNo=${bedNo}`
            )
        }
}

export default new Cabinet()



// WEBPACK FOOTER //
// ./src/service/cabinetServ.js